import React from "react";
import "../../styles/components/facultyProfile/termDetailsSection.scss";
import { Button, Descriptions, Typography, Tag, Space } from "antd";
import { EditOutlined, UpOutlined, DownOutlined } from "@ant-design/icons";

const buildItems = (fields, data) => {
  if (!fields) return [];

  return fields
    .map((field) => {
      if (!data && field.showIf) {
        return null;
      }

      if (data && field.showIf) {
        const { field: depField, value: depValue } = field.showIf;
        const actualValue = data?.[depField];
        if (actualValue != depValue) {
          return null;
        }
      }

      const value = data?.[field.name];
      let displayValue = value;

      if (value === null || value === undefined || value === "") {
        displayValue = "—";
      }

      if (field.type === "yes-no-radio") {
        if (value === 1) displayValue = "Yes";
        else if (value === 0) displayValue = "No";
        else displayValue = "—";
      }

      return {
        key: field.name,
        label: field.label,
        children: displayValue,
      };
    })
    .filter(Boolean);
};

export default function TermDetailsSection({
  title,
  fields,
  data,
  selectedTerm,
  onEdit,
  collapsed,
  onToggleCollapse,
}) {
  return (
    <div className="term-details-section">
      <div className="header">
        <div className="header-row">
          <div
            style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}
            onClick={onToggleCollapse}
          >
            <Typography.Title
              level={3}
              style={{
                margin: 0,
                color: "#862633",
              }}
            >
              {title}
            </Typography.Title>
            <Tag color="green">Included in FSR</Tag>
          </div>

          <Space>
            <Button
              size="large"
              style={{ background: "#00573F" }}
              icon={<EditOutlined />}
              type="primary"
              onClick={onEdit}
            >
              Edit
            </Button>
            <Button
              shape="circle"
              icon={collapsed ? <DownOutlined /> : <UpOutlined />}
              style={{ border: "1px solid #862633", color: "#862633" }}
              onClick={onToggleCollapse}
            />
          </Space>
        </div>

        <div>
          <span className="filter-label">Academic Term: </span>
          <Tag color="blue" style={{ fontSize: 14, fontWeight: 600, padding: "4px 10px" }}>
            {selectedTerm}
          </Tag>
        </div>
      </div>

      {!collapsed && (
        <Descriptions bordered column={1} items={buildItems(fields, data)} />
      )}
    </div>
  );
}
